import { useContext, useMemo } from 'react';
import { AuthContext } from '../context/AuthContext';
import { filterNavItemsForUser, getUserPermissions, hasPermission } from '../utils/permissions';

export function usePermissions() {
  const { user } = useContext(AuthContext);

  return useMemo(
    () => ({
      user,
      role: user?.role || user?.user?.role,
      permissions: getUserPermissions(user),
      hasPermission: (key) => hasPermission(user, key),
      navItems: filterNavItemsForUser(user),
    }),
    [user]
  );
}

export default usePermissions;
